import { InjectionToken } from '@angular/core';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { IRootState, reducersFactory } from '../store/reducers/root.reducer';
import { ActionReducer } from '@ngrx/store/src/models';
import { localStorageSync } from 'ngrx-store-localstorage';
import { AUTH_STATE_KEY } from '../store/reducers/auth.reducer';
import { FILTERS_STATE_KEY } from '../store/reducers/filters.reducer';
import { CONVERSATIONS_STATE_KEY } from '../../feature-modules/insights/pages/conversations/store/ace-conversations.reducer';
import { SCORED_CONVERSATIONS_STATE_KEY } from '../../feature-modules/insights/pages/scored-conversations/store/scored-conversations.reducer';
import { RESIDENT_CALL_REASON_STATE_KEY } from '../../feature-modules/insights/pages/resident-call-reason/store/resident-call-reason.reducer';
import { SCORECARD_QUESTIONS_STATE_KEY } from '../../feature-modules/insights/pages/scorecard-question-performance/store/scorecard-question-performance.reducer';
import { AGENT_ACTIONS_STATE_KEY } from '../../feature-modules/insights/pages/agent-actions/store/agent-actions.reducer';

export const ROOT_REDUCER_TOKEN = new InjectionToken<ActionReducerMap<IRootState>>('RootReducers', {
  providedIn: 'root',
  factory: reducersFactory,
});

export const metaReducers: MetaReducer<IRootState>[] = [localStorageSyncReducer];

export const runtimeChecks = {
  strictStateImmutability: true,
  strictActionImmutability: true,
  strictActionWithinNgZone: true,
  strictActionTypeUniqueness: true,
};

export function localStorageSyncReducer(reducer: ActionReducer<IRootState>): ActionReducer<IRootState> {
  return localStorageSync({
    keys: [
      AUTH_STATE_KEY,
      {
        [FILTERS_STATE_KEY]: [
          'accountId',
          'siteId',
          'accountIds',
          'siteIds',
          'monthVsMonth',
          'period',
          'dataLoadingMode',
          'scorecardIds',
        ],
      },
      {
        [CONVERSATIONS_STATE_KEY]: ['activeViewLabel'],
        [SCORED_CONVERSATIONS_STATE_KEY]: ['activeViewLabel'],
        [RESIDENT_CALL_REASON_STATE_KEY]: ['activeViewLabel'],
        [SCORECARD_QUESTIONS_STATE_KEY]: ['activeViewLabel'],
        [AGENT_ACTIONS_STATE_KEY]: ['activeViewLabel'],
      },
    ],
    rehydrate: true,
    storage: localStorage,
  })(reducer);
}
